import { render, staticRenderFns } from "./ListImg.vue?vue&type=template&id=ed87b49e&scoped=true"
import script from "./ListImg.vue?vue&type=script&lang=js"
export * from "./ListImg.vue?vue&type=script&lang=js"
import style0 from "./ListImg.vue?vue&type=style&index=0&id=ed87b49e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed87b49e",
  null
  
)

export default component.exports